import { IconButton, Stack } from '@fluentui/react';
import { EMergeVMStatus, IEntitiesContainerVM } from 'global/Compare/ComparisonViewModelGenerator';
import React from 'react';
 


export interface IMergeActionMenuProps {
    list: IEntitiesContainerVM;
    onPrefer: (side: EMergeVMStatus) => void;
}

export const MergeActionMenu: React.FC<IMergeActionMenuProps> = (props) => {
    return (
        <Stack
            horizontal
            tokens={{ childrenGap: 0 }}
            style={{ marginRight: '12px' }}
            onClick={(event) => event.stopPropagation()}
            onMouseDown={(event) => event.stopPropagation()}
        >
            <IconButton
                iconProps={{ iconName: 'MoreVertical' }}
                title='Merge Actions'
                ariaLabel='Merge Actions'
                styles={{ root: { minWidth: 28, width: 28, height: 28, padding: 0, } }}
                menuProps={{
                    items: [
                        {
                            key: 'prefer-origin',
                            text: 'Prefer All Origin (Replace/Add/Remove)',
                            iconProps: { iconName: 'InsertColumnsRight' },
                            onClick: () => {
                                props.onPrefer(EMergeVMStatus.UseOrigin);
                            },
                        },
                        {
                            key: 'prefer-target',
                            text: 'Prefer All Target (No Changes)',
                            iconProps: { iconName: 'InsertColumnsLeft' },
                            onClick: () => {
                                props.onPrefer(EMergeVMStatus.UseTarget);
                            },
                        },
                    ],
                }} />
        </Stack>
    );
};
